import React from "react";
import {
  PagesHero,
  MainStats,
  Motivational,
  Values,
  Story,
} from "../components";
import { useTranslation } from "../hooks/useTranslation";

function About() {
  const { t } = useTranslation();
  
  return (
    <>
      <PagesHero
        title={t("pages.about.title")}
        description={t("pages.about.description")}
        backgroundImage="/assets/images/aboutHero.jpg"
        hideLearnMore={true}
      />
      <Story />
      <Values />
      <Motivational />
      <MainStats />
    </>
  );
}

export default About;
